module.exports = __webpack_public_path__ + "assets/webgl/LM_2_1.jpg.1fda1986.webp";